// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"c2309bcc","223":"e32b6a02","239":"9956fed3","453":"c236b0ab"}[chunkId] + ".chunk.js";
};